import PicklistMetadata from "../PicklistMetadata";

// The record picker on "Add record to change order".
//
// typeValue IS USID -- THE REVISION -- AND NOT ObjectUSID, which is the exact opposite of the
// RelatedObject picklist this is modelled on, and the whole correctness of the feature. A
// relationship joins two LOGICAL objects and floats to whatever revision each is on; a change order
// acts on a SPECIFIC DRAFT and releases that draft. Yielding the logical object here would make the
// member say which record without saying which revision of it was reviewed.
//
// A LONG LIST, because the candidates are every draft in the realm.
class ChangeOrderCandidatePicklistMetadata extends PicklistMetadata {
    constructor() {
        super();

        this.name = "ChangeOrderCandidate";
        this.bounded = true;
        this.enterpriseComponent = "ChangeOrderCandidate";
        this.longList = true;
        this.noDelete = true;
        this.noUpdate = true;
        this.noInsert = true;
        this.noMerge = true;
        this.useRealm = false;
        // The current-revision floor lives in the component, not here -- a search specification is
        // what the CHOOSER types, and mixing the two let a search clear the floor.
        this.searchSpecification = null;
        this.sortSpecification = {"Name": "ASC"};
        this.static = false;
        this.typeField = "Name";
        this.typeValue = "USID";
        this.typeValue2 = null;
        this.visibilityType = null;
        this.allowNoSelection = false;
        this.allowNoSelectionValue = null;
        this.allowNoSelectionDisplayValue = null;
    }
}

export default ChangeOrderCandidatePicklistMetadata;
